import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBTextArea,
} from "mdb-react-ui-kit";
import { conditions, blurMessages } from "./constants";

const ListingDetailsStep = ({
  formData,
  processingImages,
  progress,
  blurTextIndex,
  loadingAspects,
  activeMetafields,
  loadingMetafields,
  handleAutoFill,
  handleInputChange,
  handleAspectChange,
  handleVariantChange,
  addVariant,
  removeVariant,
}) => {
  return (
    <div className="step-panel">
      {processingImages && (
        <div className="progress-bar-wrapper my-3">
          <div
            className="progress-bar-bg"
            style={{
              width: "100%",
              height: "6px",
              background: "#eee",
              borderRadius: "4px",
            }}
          >
            <div
              className="progress-bar-fill"
              style={{
                width: `${progress}%`,
                height: "100%",
                background: "#6a1b9a",
                borderRadius: "4px",
                transition: "width 0.3s",
              }}
            />
          </div>
          <span style={{ fontSize: "14px", color: "#555" }}>
            {progress}% {blurMessages[blurTextIndex]}
          </span>
        </div>
      )}
      <div className="step-header">
        <h2>Listing Details</h2>
        <p>Add comprehensive product information</p>
        <MDBBtn
          color="light"
          size="sm"
          className="auto-fill-btn"
          onClick={handleAutoFill}
        >
          Auto-Fill Listing
        </MDBBtn>
      </div>
      <MDBRow>
        <MDBCol md="12" className="mb-3">
          <h4 className="section-title">Required Information</h4>
        </MDBCol>
        <MDBCol md="12">
          <MDBInput
            label="Product Title *"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.title}
            onChange={(e) => handleInputChange("title", e.target.value)}
            required
          />
        </MDBCol>
        <MDBCol md="12">
          <MDBTextArea
            label="Product Description *"
            rows="4"
            className="mb-3"
            value={formData.description}
            onChange={(e) => handleInputChange("description", e.target.value)}
            required
          />
        </MDBCol>
        <MDBCol md="4">
          <MDBInput
            label="SKU *"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.sku}
            onChange={(e) => handleInputChange("sku", e.target.value)}
            required
          />
        </MDBCol>
        <MDBCol md="4">
          <MDBInput
            label="Price *"
            type="number"
            size="lg"
            className="mb-3"
            value={formData.price}
            onChange={(e) => handleInputChange("price", e.target.value)}
            required
            step="0.01"
            min="0"
          />
        </MDBCol>
        <MDBCol md="4">
          <MDBInput
            label="Quantity *"
            type="number"
            size="lg"
            className="mb-3"
            value={formData.quantity}
            onChange={(e) => handleInputChange("quantity", e.target.value)}
            required
            min="1"
          />
        </MDBCol>
        <MDBCol md="12" className="mb-3 mt-4">
          <h4 className="section-title">Additional Details</h4>
        </MDBCol>
        <MDBCol md="6">
          <MDBInput
            label="Brand"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.brand}
            onChange={(e) => handleInputChange("brand", e.target.value)}
          />
        </MDBCol>
        <MDBCol md="6">
          <MDBInput
            label="Color"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.color}
            onChange={(e) => handleInputChange("color", e.target.value)}
          />
        </MDBCol>
        <MDBCol md="6">
          <MDBInput
            label="Category"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.category}
            onChange={(e) => handleInputChange("category", e.target.value)}
            placeholder="Women > Clothing > Dresses"
          />
        </MDBCol>

        <MDBCol md="6">
          <label className="form-label">Product Type</label>

          <select
            className="form-select form-select-lg mb-3"
            value={formData.productType || ""}
            onChange={(e) => handleInputChange("productType", e.target.value)}
          >
            <option value="">Select Product Type</option>

            {formData.category &&
              formData.category.split(">").map((item, index) => (
                <option key={index} value={item.trim()}>
                  {item.trim()}
                </option>
              ))}
          </select>
        </MDBCol>

        <MDBCol md="4">
          <select
            className="form-select form-select-lg mb-3"
            value={formData.condition}
            onChange={(e) => handleInputChange("condition", e.target.value)}
          >
            <option value="">Select Condition</option>
            {conditions.map((condition) => (
              <option key={condition.value} value={condition.value}>
                {condition.label}
              </option>
            ))}
          </select>
        </MDBCol>
        <MDBCol md="8">
          <MDBTextArea
            label="Condition Summary"
            rows="3"
            className="mb-3"
            value={formData.condition_summary}
            readOnly
          />
        </MDBCol>
        <MDBCol md="4">
          <MDBInput
            label="Authenticity Confidence (%)"
            type="text"
            size="lg"
            className="mb-3"
            value={
              formData.authenticity_score
                ? `${formData.authenticity_score}%`
                : ""
            }
            readOnly
          />
        </MDBCol>
        <MDBCol md="8">
          <MDBTextArea
            label="Authenticity Summary"
            rows="2"
            className="mb-3"
            value={formData.authenticity_summary}
            readOnly
          />
        </MDBCol>
        <MDBCol md="4">
          <MDBInput
            label="Material"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.material}
            onChange={(e) => handleInputChange("material", e.target.value)}
          />
        </MDBCol>
        <MDBCol md="12">
          <MDBInput
            label="Tags / Keywords"
            type="text"
            size="lg"
            className="mb-3"
            value={formData.tags}
            onChange={(e) => handleInputChange("tags", e.target.value)}
            placeholder="Comma separated tags"
          />
        </MDBCol>
        <MDBCol md="12" className="mb-3 mt-4">
          <h4 className="section-title">eBay Category Aspects</h4>
          {loadingAspects ? (
            <p>Loading eBay aspects...</p>
          ) : formData.categoryAspects?.length > 0 ? (
            <MDBRow>
              {formData.categoryAspects.map((aspect) => (
                <MDBCol md="4" key={aspect.key}>
                  <MDBInput
                    label={aspect.localizedAspectName}
                    type="text"
                    size="lg"
                    className="mb-3"
                    value={aspect.value}
                    onChange={(e) =>
                      handleAspectChange(aspect.key, e.target.value)
                    }
                  />
                </MDBCol>
              ))}
            </MDBRow>
          ) : (
            <p>No aspects available for this category.</p>
          )}
        </MDBCol>
        {activeMetafields.length > 0 && (
          <>
            <MDBCol md="12" className="mb-3 mt-4">
              <h4 className="section-title">Shopify Metafields</h4>
            </MDBCol>
            {loadingMetafields ? (
              <MDBCol md="12">
                <p>Loading metafields...</p>
              </MDBCol>
            ) : (
              <>
                {activeMetafields.map((mf) => (
                  <MDBCol md="6" key={mf.id}>
                    {mf.type === "multi_line_text_field" ? (
                      <MDBTextArea
                        label={`${mf.name} - ${mf.key}`}
                        rows="3"
                        className="mb-3"
                        value={formData.metafields?.[mf.key] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            `metafields.${mf.key}`,
                            e.target.value,
                          )
                        }
                      />
                    ) : (
                      <MDBInput
                        label={`${mf.name} - ${mf.key}`}
                        type="text"
                        size="lg"
                        className="mb-3"
                        value={formData.metafields?.[mf.key] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            `metafields.${mf.key}`,
                            e.target.value,
                          )
                        }
                      />
                    )}
                  </MDBCol>
                ))}
              </>
            )}
          </>
        )}
        <MDBCol md="12" className="variants-section mt-4">
          <div className="variants-header d-flex justify-content-between align-items-center mb-3">
            <h4 className="section-title">Product Variants</h4>
            <MDBBtn
              size="sm"
              className="btn-red-outline"
              onClick={addVariant}
            >
              + Add Variant
            </MDBBtn>
          </div>
          {formData.variants.map((variant, index) => (
            <div
              key={variant.id}
              className="variant-card mb-3 p-3 border rounded"
            >
              <div className="variant-header d-flex justify-content-between align-items-center mb-2">
                <h5>Variant {index + 1}</h5>
                {formData.variants.length > 1 && (
                  <MDBBtn
                    size="sm"
                    color="light"
                    onClick={() => removeVariant(variant.id)}
                  >
                    Remove
                  </MDBBtn>
                )}
              </div>
              <MDBRow>
                <MDBCol md="4">
                  <MDBInput
                    label="Size"
                    type="text"
                    className="mb-3"
                    value={variant.size}
                    onChange={(e) =>
                      handleVariantChange(variant.id, "size", e.target.value)
                    }
                  />
                </MDBCol>
                <MDBCol md="4">
                  <MDBInput
                    label="Color"
                    type="text"
                    className="mb-3"
                    value={variant.color}
                    onChange={(e) =>
                      handleVariantChange(variant.id, "color", e.target.value)
                    }
                  />
                </MDBCol>
                <MDBCol md="4">
                  <MDBInput
                    label="Variant SKU"
                    type="text"
                    className="mb-3"
                    value={variant.sku}
                    onChange={(e) =>
                      handleVariantChange(variant.id, "sku", e.target.value)
                    }
                  />
                </MDBCol>
              </MDBRow>
            </div>
          ))}
        </MDBCol>
      </MDBRow>
    </div>
  );
};

export default ListingDetailsStep;

